import React from "react"

interface Props {
     errors: string[]
     onClear: () => void
}

const MassSaisieSubmissionError = ({ errors, onClear }: Props) => {
     if (errors.length === 0) return null

     return (
          <div className="alert alert-dismissible bg-light-danger border border-danger d-flex flex-column flex-sm-row p-5">
               <i className="fas fa-exclamation-circle fs-2hx text-danger me-4 mb-5 mb-sm-0"></i>
               <div className="d-flex flex-column pe-0 pe-sm-10">
                    <h5 className="mb-1 text-danger fw-bold">Erreurs lors de l'envoi</h5>
                    <div className="overflow-auto max-h-150px mt-2">
                         <ul className="mb-0 fs-7 fw-semibold text-gray-700">
                              {errors.map((err, i) => (
                                   <li key={i}>{err}</li>
                              ))}
                         </ul>
                    </div>
               </div>
          </div>
     )
}

export default MassSaisieSubmissionError
